import * as React from 'react'
import {
  ImageTd,
  LicenseTableContainer,
  InstructionTd,
  LicenseTr,
  NumberTd,
  StateTd,
  StyledTable,
  StyledTh,
  StyledTHead,
  UrlTd,
  LicenseWrapper,
  LicenseWrapperPreview,
  LicenseImage,
  LicenseInfo,
  LicenseState,
  LicenseNumber,
  LicenseContent,
  BoldSpan, StyledP, ViewLicenseButton, LicenseMobile, StyledA
} from './LicenseTable.elements'
import {useState} from "react";
import Analytics from "@lib/Analytics";
import {Expander} from "@components/Expander";
import {getStateName} from "@lib/util";

type License = {
  state: string;
  url: string;
  number: string;
  instruction: string;
}

export type LicenseTableProps = {
  licenses: Array<License>
}

export const LicenseTable = ({ licenses }: LicenseTableProps) => {

  const [openedLicenses, setopenedLicenses] = useState<Record<number, boolean>>({})

  const handleLicenseToggle = (index: number) => () => {
    const prevValue = openedLicenses[index]
    Analytics.log('Toggle', { location: 'faq', state: !prevValue ? 'open' : 'close' })
    setopenedLicenses({
      ...openedLicenses,
      [index]: !prevValue
    })
  }

  return (
    <LicenseTableContainer>
      <StyledTable>
        <StyledTHead>
          <tr>
            <StyledTh>State</StyledTh>
            <StyledTh>License Number</StyledTh>
            <StyledTh>License URL</StyledTh>
            <StyledTh>Instructions</StyledTh>
            <StyledTh>Image</StyledTh>
          </tr>
        </StyledTHead>
        <tbody>
        {licenses.map((d, index) => (
          <LicenseTr key={`license-tr-${index}`}>
            <StateTd>{d.state}</StateTd>
            <NumberTd>{d.number}</NumberTd>
            <UrlTd>
              <StyledA href={d.url}>
                {d.url}
              </StyledA>
            </UrlTd>
            <InstructionTd>{d.instruction}</InstructionTd>
            <ImageTd>
              <a
                href={`https://s3-us-west-2.amazonaws.com/hiq-web-images/license_images/hiq_${d.state.toLowerCase()}_lic.jpg`}>
                <img
                  src={`https://s3-us-west-2.amazonaws.com/hiq-web-images/license_images/hiq_${d.state.toLowerCase()}_lic.jpg`}
                  alt=""/>
              </a>
            </ImageTd>
          </LicenseTr>
        ))}
        </tbody>
      </StyledTable>
      <LicenseMobile>
        {licenses.map((d, index) => {
          return (
            <LicenseWrapper key={`license-wrapper-${index}`}>
              <Expander
                isOpen={!!openedLicenses[index]}
                expandedContent={(
                  <LicenseContent>
                    <StyledP>
                      <BoldSpan>License URL: </BoldSpan>
                      <a target="_blank" href={d.url}>{d.url}</a>
                    </StyledP>
                    {d.instruction &&
                      (
                        <StyledP>
                          <BoldSpan>Instructions: </BoldSpan>
                          {d.instruction}
                        </StyledP>
                      )
                    }
                    <ViewLicenseButton
                      target="_blank"
                      href={`https://s3-us-west-2.amazonaws.com/hiq-web-images/license_images/hiq_${d.state.toLowerCase()}_lic.jpg`}
                      variant="green"
                      onClick={()=> window.open(`https://s3-us-west-2.amazonaws.com/hiq-web-images/license_images/hiq_${d.state.toLowerCase()}_lic.jpg`, "_blank")}
                    >
                      View License
                    </ViewLicenseButton>
                  </LicenseContent>
                )}
                onToggle={handleLicenseToggle(index)}
              >
                <LicenseWrapperPreview>
                  <LicenseImage>
                    <a className="click-tracker" target="_blank"
                       href={`https://s3-us-west-2.amazonaws.com/hiq-web-images/license_images/hiq_${d.state.toLowerCase()}_lic.jpg`}>
                      <img
                        src={`https://s3-us-west-2.amazonaws.com/hiq-web-images/license_images/hiq_${d.state.toLowerCase()}_lic.jpg`}
                        alt="" />
                    </a>
                  </LicenseImage>
                  <LicenseInfo>
                    <LicenseState>{getStateName(d.state)}</LicenseState>
                    <LicenseNumber className="license-number">{d.number}</LicenseNumber>
                  </LicenseInfo>
                </LicenseWrapperPreview>
              </Expander>
            </LicenseWrapper>
          )
        })}
      </LicenseMobile>
    </LicenseTableContainer>
  )
}
